@if (LoggedInUser && Company) {
  <div class="container-fluid">
    <div class="page-head">
      <h1 class="page-title">Reports</h1>
    </div>

    <div class="row g-3">
      <div class="col-12 col-xl-6">
        <app-display-card [panelHeight]="'fit'">
          <div class="reports-section-head">
            <h3 class="mb-0">Standard reports</h3>
          </div>
          <ul class="reports-list">
            @if (
              !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
            ) {
              <li
                class="reports-item"
                (click)="generateSpotlightVendorsReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Spotlight vendors</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
            }
            @if (
              SortedComplianceSettings &&
              SortedComplianceSettings.length > 0 &&
              !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
            ) {
              @for (setting of SortedComplianceSettings; track setting) {
                <li
                  class="reports-item"
                  (click)="openPDFNewTab(setting.sampleCert!)"
                >
                  <i class="bi bi-filetype-pdf reports-item__icon"></i>
                  <span class="reports-item__name">
                    @if (setting.riskLevel && setting.riskLevel > 0) {
                      <span class="reports-item__meta">
                        {{ setting.CompanyComplianceType?.type }} · Risk
                        {{ RiskLevelMap.get(setting.riskLevel!) }}
                      </span>
                    }
                    <span>Sample insurance certificate</span>
                  </span>
                  <i class="bi bi-box-arrow-up-right reports-item__action"></i>
                </li>
              }
            }
            @if (
              !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
            ) {
              <li
                class="reports-item"
                (click)="generateSiteAssignedVendorsReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Site-assigned vendors</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
              <li
                class="reports-item"
                (click)="generateSuspendedVendorsReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Suspended vendors</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
            }
            @if (
              hasRiskLevelHigherThanOne &&
              !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
            ) {
              <li class="reports-item" (click)="generateTieredTradesReport()">
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Tiered trades</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
            }
            @if (
              !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
            ) {
              <li
                class="reports-item"
                (click)="generateTradesAndTradeCategoriesReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">
                  Trades and trade categories
                </span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
              <li
                class="reports-item"
                (click)="generateVendorsInReviewReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Vendors in review</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
              <li
                class="reports-item"
                (click)="generateVendorsRegisteredReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Vendors registered</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
            }
            <li class="reports-item" (click)="generateVendorStatusesReport()">
              <i class="bi bi-file-earmark-spreadsheet reports-item__icon"></i>
              <span class="reports-item__name">Vendor statuses</span>
              <i class="bi bi-download reports-item__action"></i>
            </li>
            @if (
              !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
            ) {
              <li class="reports-item" (click)="generateVendorTradesReport()">
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">
                  Trades for approved vendors
                </span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
              <li
                class="reports-item"
                (click)="generateVendorsExpiredInsuranceReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">
                  Vendors with expired insurance policies
                </span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
              <li
                class="reports-item"
                (click)="generateNewlyApprovedVendorsReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Newly approved vendors</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
            }
          </ul>
        </app-display-card>
      </div>

      @if (LoggedInUser.UserAccountRole?.role === 'CLIENT_ADMIN') {
        <div class="col-12 col-xl-6">
          <app-display-card [panelHeight]="'fit'">
            <div class="reports-section-head">
              <h3 class="mb-0">Admin reports</h3>
            </div>
            <ul class="reports-list">
              <li
                class="reports-item"
                (click)="generateComplianceSummaryReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Compliance summary</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
              @if (
                LoggedInUser.Company?.allowClientRegisteredVendors &&
                LoggedInUser.Company
                  ?.allowAutomatedBusinessVerificationClientRegisteredVendors
              ) {
                <li
                  class="reports-item"
                  (click)="generateBusinessVerifiedComplianceReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">
                    Business-verified compliance
                  </span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
              }
              <li
                class="reports-item"
                (click)="generateComplianceDetailReport()"
              >
                <i
                  class="bi bi-file-earmark-spreadsheet reports-item__icon"
                ></i>
                <span class="reports-item__name">Compliance detail</span>
                <i class="bi bi-download reports-item__action"></i>
              </li>
              @if (
                !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
              ) {
                <li class="reports-item" (click)="generateFeeVouchersReport()">
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">Fee vouchers</span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
                <li
                  class="reports-item"
                  (click)="generateInsuranceTypeAndDatesReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">
                    Insurance types and dates
                  </span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
                <li
                  class="reports-item"
                  (click)="generateAPInsuranceTypeAndDatesReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">
                    AP insurance types and dates
                  </span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
                <li
                  class="reports-item"
                  (click)="generateLinkedVendorsReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">Linked vendors</span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
                <li
                  class="reports-item"
                  (click)="generateVendorPaymentDetailReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">Vendor payment detail</span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
                <li
                  class="reports-item"
                  (click)="generateVendorPaymentSummaryReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">Vendor payment summary</span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
              }
              @if (
                LoggedInUser.Company?.allowClientRegisteredVendors &&
                LoggedInUser.Company
                  ?.allowAutomatedBusinessVerificationClientRegisteredVendors
              ) {
                <li
                  class="reports-item"
                  (click)="generateBusinessVerifiedVendorInvoicesReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">
                    Business-verified vendor invoices
                  </span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
                <li
                  class="reports-item"
                  (click)="generateBusinessVerificationOverrideReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">
                    Business verification override
                  </span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
              }
              @if (
                userHasSpecificAccountingSystem('Cinc') &&
                !LoggedInUser.Company?.verifyClientRegisteredVendorBusinessOnly
              ) {
                <li
                  class="reports-item"
                  (click)="generateSiteAssignmentsForAPReport()"
                >
                  <i
                    class="bi bi-file-earmark-spreadsheet reports-item__icon"
                  ></i>
                  <span class="reports-item__name">
                    Site assignments for accounts payable
                  </span>
                  <i class="bi bi-download reports-item__action"></i>
                </li>
              }
            </ul>
          </app-display-card>
        </div>
      }
    </div>
  </div>
}
